import 'slick-carousel';

class Sliders{

  sliderBlocks(){
    const slider =  $('[data-js-slider]');

    if(!slider){
      return;
    }
    slider.slick({
      infinite: true,
      dots: true,
      slidesToShow: 3,
      slidesToScroll: 3,
      responsive: [
        {
          breakpoint: 1023,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 640,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  }

  sliderTestimonials(){

    const slider =   $('[data-js-testimonials]');
    if(!slider){
      return;
    }

    slider.slick({
      infinite: true,
      dots: true,
      slidesToShow: 1,
      slidesToScroll: 1,
    });
  }

  sliderPloyee(){
    const slider = $('[data-js-ployee]');
    if(!slider){
      return;
    }

    slider.slick({
      infinite: true,
      dots: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      mobileFirst: true,
      responsive: [
        {
          breakpoint: 640,
          settings: 'unslick'
        }
      ]
    });
  }
}

export {Sliders};